class LocalStorage {
  set(key: string, value: any, expirationInSeconds: number = null): void {
    const data = {
      value,
      expiresIn:
        expirationInSeconds === null ? null : new Date().getTime() + expirationInSeconds * 1000,
    };

    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      //
    }
  }

  get(key: string): any {
    let data;
    try {
      data = JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return localStorage.getItem(key);
    }

    if (data !== null) {
      if (data.expiresIn !== null && data.expiresIn < new Date().getTime()) {
        localStorage.removeItem(key);
      } else {
        return data.value;
      }
    }
    return null;
  }

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      //
    }
  }
}

export default new LocalStorage();
